import * as React from "react";
import { v4 as uuid } from "uuid";

import CopyTextButton from "~/components/shared/CopyTextButton";

type Props = {
  children: React.ReactNode;
  language?: string;
  showCopyButton?: boolean;
};

export default function CodeBlock({ showCopyButton, ...props }: Props) {
  const id = `code-block-${uuid()}`;

  return (
    <div className="relative">
      <pre id={id} className="bg-silver monospace border-gray overflow-auto rounded border p-2">
        <code
          style={{
            fontFamily:
              '"SFMono-Regular", Monaco, Menlo, Consolas, "Liberation Mono", Courier, monospace',
            fontSize: ".9em",
          }}
          className={props.language && `language-${props.language}`}
        >
          {props.children}
        </code>
      </pre>
      <CopyTextButton
        element={`#${id}`}
        className="border-gray absolute right-2.5 top-2.5 flex h-8 w-8 items-center justify-center rounded border"
      />
    </div>
  );
}
